import styled from "styled-components";

export const ModalContainer = styled.div`
  width: 100%;
  box-shadow: var(--shadow-panel);
  overflow: hidden;
  max-height: 90dvh;
  overflow-y: auto;
  max-width: 400px;
  position: relative;
  z-index: 1000;

  border-radius: 30px;
  border: 1px solid var(--color-line);
  background:
    radial-gradient(
      circle at top right,
      rgba(var(--color-brand-400-rgb), 0.14),
      transparent 0 34%
    ),
    linear-gradient(
      180deg,
      rgba(28, 43, 68, 0.96) 0%,
      rgba(18, 24, 36, 0.98) 100%
    );
`;

export const ModalTitle = styled.h2`
  font-family: var(--font-family-primary);
  color: var(--color-text-strong);
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.03em;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;
export const SmallRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const FavoriteButton = styled.button`
  cursor: pointer;
  border: 0.5px solid rgba(var(--color-brand-300-rgb), 0.14);
  outline: none;
  position: relative;
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.68) 0%,
    rgba(18, 24, 36, 0.88) 100%
  );
  width: 34px;
  height: 34px;
  border-radius: var(--radius-pill);
`;
export const Tags = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
`;

export const Tag = styled.div`
  color: var(--color-text-strong);
  font-family: var(--font-family-primary);
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.01em;

  display: flex;
  padding: 4px 10px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: var(--radius-pill);
  border: 1px solid rgba(var(--color-brand-300-rgb), 0.14);
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.62) 0%,
    rgba(18, 24, 36, 0.86) 100%
  );
  box-shadow: inset 0 1px 0.4px rgba(255, 255, 255, 0.05);
`;

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 34px;
  height: 34px;
  border-radius: var(--radius-pill);
  border: 1px solid rgba(var(--color-brand-300-rgb), 0.14);
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.68) 0%,
    rgba(18, 24, 36, 0.88) 100%
  );
  color: var(--color-text-muted);

  &:hover {
    opacity: 1;
  }
`;

export const ModalContent = styled.div`
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  text-align: center;
`;

export const ImageContainer = styled.div`
  position: relative;
`;
export const UploadButton = styled.button`
  border-radius: var(--radius-pill);
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.9) 0%,
    rgba(18, 24, 36, 0.92) 100%
  );
  backdrop-filter: blur(6.85px);
  -webkit-backdrop-filter: blur(6.85px);

  display: flex;
  width: 100%;
  max-width: 248px;
  height: 44px;
  padding: 9px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  position: absolute;
  cursor: pointer;

  outline: none;
  border: 1px solid rgba(var(--color-brand-300-rgb), 0.16);
  left: 50%;
  bottom: 8px;

  transform: translateX(-50%);

  color: var(--color-text-strong);
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.01em;
`;
export const Image = styled.img`
  width: 100%;
  border-radius: 20px;
  max-height: 260px;
  pointer-events: none;
  aspect-ratio: 9/6;
  object-fit: cover;
`;

export const ModalMessage = styled.p`
  color: var(--color-text-muted);
  text-align: left;
  font-family: var(--font-family-primary);
  font-size: 15px;
  font-weight: 400;
  line-height: normal;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const CancelButton = styled.button`
  display: flex;
  width: 110px;
  height: 40px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: var(--radius-pill);
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.66) 0%,
    rgba(18, 24, 36, 0.88) 100%
  );
  border: 1px solid var(--color-line);
  outline: none;

  color: var(--color-text-strong);
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: rgba(var(--color-brand-300-rgb), 0.1);
    border-color: var(--color-line-strong);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ConfirmButton = styled.button`
  display: flex;
  min-width: 110px;
  height: 40px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: var(--radius-pill);
  background: ${({ $type }) => {
    switch ($type) {
      case "danger":
        return "linear-gradient(135deg, #ff4757, #ff3838)";
      case "success":
        return "linear-gradient(180deg, var(--color-brand-500) 0%, var(--color-brand-600) 100%)";
      case "primary":
      default:
        return "linear-gradient(180deg, var(--color-brand-500) 0%, var(--color-brand-600) 100%)";
    }
  }};
  border: 1px solid rgba(var(--color-brand-400-rgb), 0.18);
  outline: none;

  color: #07111f;
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.01em;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: ${({ $type }) => {
      switch ($type) {
        case "danger":
          return "0 4px 15px rgba(255, 71, 87, 0.3)";
        case "success":
          return "var(--shadow-cta)";
        case "primary":
        default:
          return "var(--shadow-cta)";
      }
    }};
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const NudifyContainer = styled.div`
  border-radius: 18px;
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.7) 0%,
    rgba(18, 24, 36, 0.92) 100%
  );
  display: flex;
  padding: 8px 10px;
  align-items: center;
  cursor: pointer;
  gap: 10px;
  align-self: stretch;
  flex-direction: row;
  border: 1px solid rgba(var(--color-brand-300-rgb), 0.14);
`;

export const NudifyText = styled.span`
  font-family: var(--font-family-primary);
  color: var(--color-text-body);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
`;

export const SettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const LabelText = styled.span`
  color: var(--color-text-body);
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.01em;
  text-align: left;
`;
export const PromptRow = styled.div`
  display: flex;
  flex-direction: row;

  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  @media (max-width: 400px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const Textarea = styled.textarea`
  display: flex;
  height: 44px;
  padding: 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  border-radius: 20px;
  border: 1px solid var(--color-line);
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.68) 0%,
    rgba(18, 24, 36, 0.88) 100%
  );

  font-family: var(--font-family-primary);
  color: var(--color-text-strong);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;

  resize: vertical;
  min-height: 126px;
  outline: none;
`;
export const Input = styled.input`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  align-self: stretch;
  border: 1px solid transparent;
  border-radius: 18px;

  color: var(--color-text-strong);
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
  transition: border-color 0.2s ease;

  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.72) 0%,
    rgba(18, 24, 36, 0.9) 100%
  );
  padding: 10px 12px;

  &:focus {
    border-color: var(--color-brand-700);
  }

  &::placeholder {
    color: var(--color-text-dim);
    opacity: 1;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  width: 100%;
`;

export const Checkbox = styled.div`
  display: flex;
  padding: 6px 8px;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  cursor: pointer;
  border-radius: 18px;
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.7) 0%,
    rgba(18, 24, 36, 0.92) 100%
  );
  border: 1px solid rgba(var(--color-brand-300-rgb), 0.14);
`;

export const CheckboxText = styled.span`
  color: var(--color-text-body);
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
`;

export const Button = styled.button`
  display: flex;
  padding: 6px 4px;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  flex: 1;
  border-radius: var(--radius-pill);
  border: ${(p) =>
    !p.$active
      ? "1px solid transparent"
      : "1px solid rgba(var(--color-brand-400-rgb), 0.18)"};
  background: ${(p) =>
    p.$active
      ? "linear-gradient(180deg, var(--color-brand-700) 0%, var(--color-brand-700) 56%, var(--color-brand-700) 100%)"
      : "transparent"};

  position: relative;
  transition: all 0.3s ease-in-out;
  opacity: ${(p) => (p.$disabled ? 0.5 : 1)};
  cursor: ${(p) => (p.$disabled ? "default" : "pointer")};
  outline: none;

  color: ${(p) =>
    p.$active ? "var(--color-text-strong)" : "var(--color-text-body)"};
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;

  span {
    color: ${(p) =>
      p.$active
        ? "rgba(var(--glass-pale-rgb), 0.76)"
        : "var(--color-text-dim)"};
    font-family: var(--font-family-primary);
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.01em;
  }
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  border-radius: 18px;
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.72) 0%,
    rgba(18, 24, 36, 0.9) 100%
  );
  flex: 1;
  padding: 4px;
  align-items: center;
  border: 1px solid var(--color-line);
`;
